export default __webpack_public_path__ + "media/images/cooksGreenLogo-afdebec00a61154fbff72da79cb6333f.svg";